import {parsePhoneNumber} from "awesome-phonenumber";
import moment from "moment-timezone";
import isEmail from "validator/lib/isEmail";

/**
 * Validator which requires a non-empty input.
 */
export const required =
  (msg?: string) =>
  (input?: string): string | undefined => {
    if (!input) {
      if (msg) {
        return msg;
      }
      return "";
    }
    return undefined;
  };

export const requireEmail =
  (msg: string) =>
  (input: string): string | undefined => {
    if (!isEmail(input)) {
      return msg;
    }
    return undefined;
  };

export const validateDate =
  ([requiredDate, invalidDate, futureDate, tooYoungDate]: [string, string, string, string?]) =>
  (input: string): string | undefined => {
    if (!input) {
      return requiredDate;
    }
    const date = moment(input, "MM/DD/YYYY", true);
    const dateNow = moment(new Date());

    if (!date.isValid()) {
      return invalidDate;
    }

    if (date.isAfter(dateNow)) {
      return futureDate;
    }
    const tooYoungMoment = moment(dateNow).subtract(16, "years").startOf("day");
    if (date.isAfter(tooYoungMoment)) {
      return tooYoungDate;
    }

    return undefined;
  };

export const validatePhoneNumber =
  (msg: string) =>
  (num: string, regionSlug: string): string | undefined => {
    if (num && typeof num === "string") {
      const phoneNum = parsePhoneNumber(num, {regionCode: regionSlug});
      const isValid = phoneNum.valid;

      if (!isValid) {
        return msg;
      }
      return undefined;
    }
  };
